// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1Gxbg","select":"Header_select__1kxPR","clinic":"Header_clinic__3lCEG"};